/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { z } from 'zod';

/** Compose a message (Figma chat composer). Mirrors the API `SendMessageDto`. */
export const SendMessageSchema = z.object({
  body: z.string().trim().min(1, 'Type a message').max(5000),
});
export type SendMessageInput = z.infer<typeof SendMessageSchema>;

/** Start a conversation with a contact. Mirrors the API `StartThreadDto`. */
export const StartThreadSchema = z.object({
  recipientUserId: z.string().uuid('Select a contact'),
});
export type StartThreadInput = z.infer<typeof StartThreadSchema>;
